// extracted by mini-css-extract-plugin
module.exports = {"loader":"ThreeDotsContent_loader__Tmmap","multi-pulse":"ThreeDotsContent_multi-pulse__q1F63"};